// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qsoEI1","alert":"thDD04","warn":"Wh6akk","warnIcon":"svr4_q","content":"iBFvY3","buttons":"bo6DBe"};